<script setup lang="ts">
  defineProps<{
    isActive: boolean
  }>()
</script>

<template>
  <Transition name="fade">
    <div
      v-if="isActive"
      data-testid="search-scrim"
      aria-hidden="true"
      class="fixed inset-0 z-0 bg-black/30 backdrop-blur-md"
    />
  </Transition>
</template>

<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 300ms ease;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
</style>
